module.exports = __webpack_public_path__ + "static/fonts/fa-regular-400.e0cce88.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-regular-400.eot
// module id = 3uyd
// module chunks = 12